import { defineComponent as _defineComponent } from 'vue'
import { useHotelDescriptionRepository } from '@entities/hotelDescription';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelDescriptionMainText',
  setup(__props) {

    const { hotelDescriptionMainText } = useHotelDescriptionRepository();

return { __sfc: true,hotelDescriptionMainText }
}

})